import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

interface StyledFormProps extends React.HTMLAttributes<HTMLFormElement> {
  onSubmit?: React.FormEventHandler<HTMLFormElement>
  children?: React.ReactNode
  isDisabled?: boolean
  formRef?: React.Ref<HTMLFormElement>
}

const StyledForm = styled(
  ({ onSubmit, children, isDisabled, formRef, ...props }: StyledFormProps) => (
    <Box
      component="form"
      onSubmit={onSubmit}
      ref={formRef}
      {...props}
      sx={{ pointerEvents: isDisabled ? 'none' : 'auto', opacity: isDisabled ? 0.5 : 1 }}
    >
      {children}
    </Box>
  )
)(({ theme }) => ({
  '& .MuiFormControl-root': {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  '& .MuiButton-root[type="submit"]': {
    marginTop: theme.spacing(2)
  },
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.background.default
  }
}))

export default StyledForm
